/**
 * Compact relative time — "just now", "3m ago", "2h ago", "5d ago".
 *
 * Moved out of `QuizContentManagement.tsx` by feat-270 for the same reason the
 * diff presentation moved: the approval queue is a second consumer, and the
 * alternatives were both worse than a move. Importing it from a 4800-line module
 * would have made the queue depend on the whole editor — and once the editor
 * imports the approval components back (the header badge and tree chips, AT-25)
 * that dependency becomes a CYCLE. Copying the six lines would have forked a
 * function whose whole job is that two surfaces say "2h ago" the same way.
 *
 * `QuizContentManagement.tsx` re-exports it, so every existing importer and test
 * keeps working against the same single definition.
 *
 * NOT to be confused with `ContentTimestamps`, which renders absolute stamps and
 * answers a different question.
 */

/** Falls back to the raw string if it isn't a parseable date. */
export function timeAgo(iso: string): string {
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return iso;
  const secs = Math.floor((Date.now() - then) / 1000);
  if (secs < 45) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}
